import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {ImportContainer} from "../../../Model/dataProcess/importContainer";
import {ImportContainerService} from "../../../Services/DataProcess/import-container.service";
import {SignalrService} from "../../../Services/signalr.service";
import {LoginService} from "../../../Services/login.service";
import {PreparationContainer} from "../../../Model/dataProcess/PreparationContainer";
import {PreparationContainerService} from "../../../Services/DataProcess/preparation-container.service";
import {CatalogService} from "../../../Services/CatalogManagement/catalog.service";
import {DxContextMenuComponent} from "devextreme-angular";
import {TranslateService} from "@ngx-translate/core";
import {SystemService} from "../../../Services/system.service";

@Component({
  selector: 'app-prepare-stage',
  templateUrl: './prepare-stage.component.html',
  styleUrls: ['./prepare-stage.component.css']
})
export class PrepareStageComponent implements OnInit {

  @ViewChild('rowMenu', { static: false })
  rowMenu?: DxContextMenuComponent;
  
  @Output() containerSaved = new EventEmitter<ImportContainer>();
  public selectedCatalogId: string = "";
  public container: ImportContainer = null;
  public preparationContainer: PreparationContainer = null;
  preparationCatalogs: { id: string; name: string }[] = [];
  archivCatalogs: { id: string; name: string }[] = [];
  isArchiveLoading: boolean = false;
  toArchive: boolean = true;
  
  constructor(
    private readonly loginService: LoginService,
    private readonly preparationContainerService: PreparationContainerService,
    private readonly catalogService: CatalogService,
    private readonly translate: TranslateService,
    private readonly systemService: SystemService
  ) {
    this.loadCatalogLists = this.loadCatalogLists.bind(this);
  }

  async ngOnInit()  {
    this.preparationContainer = await this.preparationContainerService.getPreparationContainer(this.loginService.currentCustomer.id);
    await this.loadCatalogLists();
  }

  searchEditorOptions = {
    placeholder: this.translate.instant('Suchen…'),
    showClearButton: true
  };

  searchEditorOptionsArchive = { 
    placeholder: this.translate.instant('Archiv durchsuchen…'), 
    showClearButton: true 
  };
  
  rowMenuItems = [
    { id: 'before', text: this.translate.instant('Katalog ins Archiv verschieben') },
  ];

  async onMenuItemClick(event: any) {
    this.preparationContainer = 
      await this.preparationContainerService.moveCatalog(
        this.selectedCatalogId,
        this.preparationContainer.id, 
        this.toArchive,
        this.loginService.currentCustomer.id
      )
    if (this.preparationContainer) {
      await this.loadCatalogLists();
      this.systemService.notifyInfo(this.translate.instant('Katalog erfolgreich verschoben'));
    }
  }

  async onCatalogRowClick(catalogId: string | null | undefined) {
    if (!catalogId) {
      return;
    }
    this.selectedCatalogId = catalogId;
  }

  openRowMenu(e: any, toArchive: boolean) {
    this.toArchive = toArchive;
    if(toArchive) {
      this.rowMenuItems = [
        { id: 'before', text: this.translate.instant('Katalog ins Archiv verschieben') },
      ];
    }
    else {
      this.rowMenuItems = [
        { id: 'before', text: this.translate.instant('Katalog aus Archiv wiederherstellen') },
      ];
    }
    const targetElement = e.element as HTMLElement;
    this.rowMenu?.instance.option('target', targetElement);

    this.rowMenu?.instance.show();
  }

  private async loadCatalogLists() {
    const customerId = this.loginService.currentCustomer.id;
    this.preparationCatalogs = await Promise.all(
      this.preparationContainer.preparationCatalogIds.map(async id => ({
        id,
        name: await this.catalogService.getCatalogName(id, customerId)
      }))
    );
    this.archivCatalogs = await Promise.all(
      this.preparationContainer.archivCatalogIds.map(async id => ({
        id,
        name: await this.catalogService.getCatalogName(id, customerId)
      }))
    );
  }

  onEditClicked() {
    this.systemService.notifyInfo("Funktion wurde noch nicht implementiert");
  }
}
